import React, { useState, useEffect, useMemo } from 'react';
import { AuditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Input, Select, Row, Col } from 'antd';
import { CIC_REASON, CIC_REASON_FREE_FORM } from 'static/Constants';
import {
  Form,
  StyledModal,
  FormAddButton,
  dialogFunction,
  WrapperSelect,
} from 'common/components';
import { useDispatchReloadPage } from 'hooks/useReloadPage';
import { apiHandler } from 'utils/api';
import { useIntl } from 'react-intl';

import RibbonButton from 'common/components/button/RibbonButton';
import * as productServices from 'services/product';
import Messages from 'i18n/messages/home';

import { filterParams, getUniqueReasons, mappingReason } from './utils';

import './index.less';

const { Option } = Select;

const ReviewPublication = (props) => {
  const {
    selectionPublication,
    sectionDisabled,
    onRefetchNavigationMenu,
    onClearItemGrid,
  } = props;

  const [isOpenModalReview, setIsOpenModalReview] = useState(false);
  const [form] = Form.useForm();

  const [reasons, setReasons] = useState([{ displayText: '' }]);

  const reloadPage = useDispatchReloadPage();
  const intl = useIntl();

  const uniqueReasons = useMemo(() => {
    return getUniqueReasons(reasons);
  }, [reasons]);

  const isHiddenAddReason = reasons?.length === CIC_REASON.length;

  useEffect(() => {
    if (!isOpenModalReview) {
      setReasons([{ displayText: '' }]);
    }
  }, [isOpenModalReview]);

  const onClickBtn = () => {
    setIsOpenModalReview(true);
  };

  const handleOk = () => {
    form.validateFields().then((values) => {
      const mappingValues = mappingReason(values);
      const filteredValues = filterParams(mappingValues);
      callApiReviewPublication(filteredValues);
    });
  };

  const callApiReviewPublication = (values) => {
    const params = {
      id: selectionPublication?.id,
      ...values,
    };

    const successMessage = intl.formatMessage(
      Messages.reviewPublicationSuccess
    );
    const errorMessage = intl.formatMessage(Messages.reviewPublicationError);

    apiHandler({
      service: productServices.reviewPublication,
      params,
      successMessage,
      errorMessage,
      successCallback,
    });
  };
  const successCallback = () => {
    form.resetFields();
    reloadPage();
    onRefetchNavigationMenu();
    onClearItemGrid();
    setIsOpenModalReview(false);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsOpenModalReview(false);
  };

  const handleRemoveReason = (key) => {
    const newReasons = [...reasons.slice(0, key), ...reasons.slice(key + 1)];
    setReasons(newReasons);
  };

  const checkDisabled = () => {
    const status = selectionPublication?.status;
    const statusDisabled = status && status?.toLowerCase() !== 'pending';
    return sectionDisabled || statusDisabled;
  };

  const handleChangeReason = (value, key) => {
    let foundReason = reasons[key];

    foundReason = {
      ...foundReason,
      displayText: value,
    };

    const newReasons = [
      ...reasons.slice(0, key),
      foundReason,
      ...reasons.slice(key + 1),
    ];

    setReasons(newReasons);
  };

  return (
    <>
      <RibbonButton
        size='small'
        icon={<AuditOutlined />}
        label={Messages.reviewSubscription}
        onClick={onClickBtn}
        disabled={checkDisabled()}
      />

      {isOpenModalReview && (
        <StyledModal
          title={intl.formatMessage(Messages.reviewGDSNPublication)}
          visible={isOpenModalReview}
          onOk={handleOk}
          onCancel={handleCancel}
          destroyOnClose
        >
          <Form
            name='review-publication'
            autoComplete='off'
            initialValues={{
              gdsnCicReasons: [
                { displayText: null, additionalDescription: '' },
              ],
            }}
            form={form}
            layout='vertical'
            className='review-publication'
          >
            <Form.List name='gdsnCicReasons'>
              {(fields, { add, remove }) => (
                <Row>
                  {fields.map(({ key, name, fieldKey, ...restField }) => (
                    <React.Fragment key={key}>
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          style={{ width: '100%' }}
                          label={
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%',
                              }}
                            >
                              <span>CIC Reason</span>
                              {fields?.length > 1 && (
                                <DeleteOutlined
                                  style={{
                                    fontSize: 17,
                                    paddingTop: 2,
                                    paddingLeft: 5,
                                    color: '#ff4d4f',
                                  }}
                                  onClick={() => {
                                    dialogFunction({
                                      type: 'warn',
                                      content:
                                        'Are you sure want to delete the selecting reason?',
                                      onOk: () => {
                                        remove(name);
                                        handleRemoveReason(name);
                                      },
                                    });
                                  }}
                                />
                              )}
                            </div>
                          }
                          name={[name, 'reason']}
                          fieldKey={[fieldKey, 'reason']}
                          rules={[
                            {
                              required: true,
                              message: 'CIC Code is required',
                            },
                          ]}
                        >
                          <WrapperSelect
                            showSearch
                            placeholder='CIC Reason'
                            filterOption={(input, option) =>
                              option.children
                                ?.toLowerCase()
                                .indexOf(input?.toLowerCase()) >= 0
                            }
                            onChange={(value) => {
                              handleChangeReason(value, key);
                            }}
                          >
                            {uniqueReasons.map((item, idx) => (
                              <Option key={idx} value={item.displayText}>
                                {item.displayText}
                              </Option>
                            ))}
                          </WrapperSelect>
                        </Form.Item>
                        {reasons?.[key]?.displayText ===
                          CIC_REASON_FREE_FORM.displayText && (
                          <Form.Item
                            {...restField}
                            label='Additional Description'
                            name={[name, 'additionalDescription']}
                            fieldKey={[fieldKey, 'additionalDescription']}
                          >
                            <Input.TextArea
                              placeholder='Additional Description'
                              rows={4}
                            />
                          </Form.Item>
                        )}
                      </Col>
                    </React.Fragment>
                  ))}

                  {isHiddenAddReason ? null : (
                    <Col span={24}>
                      <FormAddButton
                        text={'Add Field'}
                        style={{ borderRadius: 'none' }}
                        onClick={() => {
                          add();
                          setReasons((prevReasons) =>
                            prevReasons.concat({
                              displayText: '',
                            })
                          );
                        }}
                      />
                    </Col>
                  )}
                </Row>
              )}
            </Form.List>
          </Form>
        </StyledModal>
      )}
    </>
  );
};

export default ReviewPublication;
